import React from 'react';
import { Body1, Title2, mergeClasses } from '@fluentui/react-components';
import { useAccessMessageStyles } from '../styles/AccessMessage.styles';

interface AccessMessageProps {
  icon: React.ReactElement;
  title: string;
  body: string;
  supporting?: React.ReactNode;
  /** Buttons rendered under the message. */
  actions?: React.ReactNode;
  /**
   * Center the message on the full viewport instead of inside the app shell.
   * Use for pages rendered outside the layout (unauthenticated experiences).
   */
  fullScreen?: boolean;
}

/**
 * Shared presentation for the access related messages (not signed in, not
 * entitled to the app, not entitled to a page). 
 */
export const AccessMessage: React.FC<AccessMessageProps> = ({
  icon,
  title,
  body,
  supporting,
  actions,
  fullScreen = false,
}) => {
  const styles = useAccessMessageStyles();

  return (
    <div className={mergeClasses(styles.container, fullScreen && styles.fullScreen)}>
      <div className={styles.content}>
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
        <Title2 className={styles.title}>{title}</Title2>
        <Body1 className={styles.body}>{body}</Body1>
        {supporting && <Body1 className={styles.body}>{supporting}</Body1>}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
};
